export default function WhatIsSection() {
  return (
    <section id="what-is" className="py-14 md:py-20 px-4 md:px-6 bg-background-100/60">
      <div className="max-w-7xl mx-auto">
        <div className="max-w-3xl mx-auto text-center">
          <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-4">
            What Is Sugargoo Spreadsheet
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-5">
            Understanding the Sugargoo Spreadsheet Resource
          </h2>
          <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-8">
            <strong>Sugargoo Spreadsheet</strong> is an organized product research resource that helps shoppers discover trending items, compare products, check categories and improve their Sugargoo shopping experience. Instead of manually browsing through endless listings, the spreadsheet format organizes everything into clear, filterable categories &mdash; saving you hours of research time and helping you find exactly what you need.
          </p>

          <div className="overflow-x-auto">
            <table className="w-full text-left border-collapse">
              <thead>
                <tr className="border-b border-background-300/60">
                  <th className="py-3 px-4 text-sm font-semibold text-foreground-800 whitespace-nowrap">Feature</th>
                  <th className="py-3 px-4 text-sm font-semibold text-foreground-500 whitespace-nowrap">Manual Search</th>
                  <th className="py-3 px-4 text-sm font-semibold text-primary-700 whitespace-nowrap">Sugargoo Spreadsheet</th>
                </tr>
              </thead>
              <tbody>
                {[
                  { feature: 'Product Discovery', manual: 'Slow & Unorganized', spreadsheet: 'Fast & Organized' },
                  { feature: 'Finding Trends', manual: 'Difficult', spreadsheet: 'Easy' },
                  { feature: 'Category Filtering', manual: 'No', spreadsheet: 'Yes' },
                  { feature: 'Product Research', manual: 'Time Consuming', spreadsheet: 'Much Faster' },
                  { feature: 'Shopping Planning', manual: 'Limited', spreadsheet: 'Advanced' },
                ].map((row) => (
                  <tr key={row.feature} className="border-b border-background-200/70">
                    <td className="py-3 px-4 text-sm font-medium text-foreground-800 whitespace-nowrap">{row.feature}</td>
                    <td className="py-3 px-4 text-sm text-foreground-500 whitespace-nowrap">{row.manual}</td>
                    <td className="py-3 px-4 text-sm text-primary-700 font-medium whitespace-nowrap">{row.spreadsheet}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </section>
  );
}